import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

// Retrieve stored login state from localStorage
const storedIsLoggedIn = Cookies.get("isLoggedIn") === "true";
const storedUserInfo = JSON.parse(localStorage.getItem("userInfo")) || { name: "" };

const initialState = {
    userInfo: storedUserInfo,
    isLoggedIn: storedIsLoggedIn,
    place_API_token : ""
};

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
            localStorage.setItem("isLoggedIn", action.payload); // Persist to localStorage
        },

        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
            localStorage.setItem("userInfo", JSON.stringify(action.payload)); // Persist user info
        },

        logout: (state) => {
            state.isLoggedIn = false;
            state.userInfo = { userId: "", userName: "" };
            Cookies.remove('authToken');
            Cookies.remove('isLoggedIn');
        },

        setPlaceAPIToken: (state, action) => {
            state.place_API_token = action.payload;
        },
    },
});

export const { setIsLoggedIn, setUserInfo, logout, setPlaceAPIToken } = authSlice.actions;
export const authReducer = authSlice.reducer;
